import { ActionType } from '@state';

export interface IGenericState {
    exitingNavigation: boolean;
    toPath: string;
}
export interface IConsignmentOptionState {
    isOpenViewersModal: boolean;
    isScrollToCommentSection: boolean;
    isOpenBuyerModal: boolean;
}

export const GenericActionTypes = {
    resetGeneric: 'resetGeneric',
    setNavigation: 'setNavigation',
    setOptionStateAction: 'setOptionStateAction',
    resetOptionStateAction: 'resetOptionStateAction',
};

export const GenericInitialState: IGenericState = {
    exitingNavigation: false,
    toPath: '',
};

export const ConsignmentOptionsState: IConsignmentOptionState = {
    isOpenViewersModal: false,
    isScrollToCommentSection: false,
    isOpenBuyerModal: false,
};

function reducer<T extends IGenericState | IConsignmentOptionState>(state: T, action: ActionType): T {
    switch (action.type) {
        case GenericActionTypes.setNavigation:
            return action.value.payload as T;
        case GenericActionTypes.resetGeneric:
            return GenericInitialState as unknown as T;
        case GenericActionTypes.setOptionStateAction:
            return action.value.payload as T;
        case GenericActionTypes.resetOptionStateAction:
            return ConsignmentOptionsState as unknown as T;
        default:
            return state;
    }
}

export default reducer;
